/** @format */

import styled from 'styled-components';

export const ModalContiner = styled.div`
	width: 100vw;
	height: 100vh;
	z-index: 40;
	position: fixed;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const ModalWrapper = styled.div`
	width: 392px;
	height: 149px;
`;

export const HeaderContainer = styled.div`
	width: 100%;
	height: 60px;
	padding: 0 24px;
	display: inline-flex;
	background: #ffff7a;
	justify-content: space-between;
	align-items: center;
	border-radius: 20px 20px 0px 0px;
`;

export const TitleWrapper = styled.div`
	color: #3d392c;
	font-weight: 600;
	font-size: 20px;
	line-height: 28px;
	text-align: center;
`;

export const CloseWrapper = styled.div`
	width: 24px;
	height: 24px;
	background: transparent;
	cursor: pointer;
`;

export const BodyContainer = styled.div`
	background: #ffffff;
	padding: 16px 24px;
	border-radius: 0px 0px 20px 20px;
`;

export const InnerContainer = styled.div`
	display: inline-flex;
	width: 100%;
	height: 57px;
	padding: 0 24px;
	background: rgba(61, 57, 44, 0.1);
	border-radius: 20px;
	justify-content: space-between;
	align-items: center;
`;

export const UrlWrapper = styled.div`
	width: 213px;
	height: 24px;
	white-space: nowrap;
	overflow: hidden;
	opacity: 0.4;
	margin-right: 13px;

	::selection {
		background: yellow;
	}
`;
